import React from "react";
import { useTranslation } from "react-i18next";
import SectionCardContainer from "../../components/sections/SectionCardContainer";
import YellowDivider from "../../components/dividers/YellowDivider";
import SectionComingSoon from "../../components/sections/SectionComingSoon";
import FeaturedCafeContent from "../../components/contentpreview/FeaturedCafeContent";
import FeaturedAcademyContent from "../../components/contentpreview/FeaturedAcademyContent";
import { PreviewSections } from "../../components/sections/PreviewSections";
import PageHeadingWithImage from "../../components/pageheading/PageHeadingWithImage";
import { Link } from "react-router-dom";
import Button from "../../components/singlecomponents/Button";
import "../../stylesheet/pages/HubPage.scss";
import Skeleton from "react-loading-skeleton";

const HubPage: React.FC = () => {
  const { t, i18n, ready } = useTranslation();
  let lang = 0;
  let newsCategory = "News";
  if (i18n.language === "ar") {
    lang = 1;
    newsCategory = "أخبار";
  }

  return (
    <div className="main">
      <div className="container pt-4">
        <h1> {ready ? `${t("hub.welcome")}` : <Skeleton width={300} />}</h1>
        <YellowDivider heading="h1" />
        <SectionCardContainer />
        <FeaturedAcademyContent
          title={t("titlecard-zeacademy.title")}
          subtitle={t("titlecard-zeacademy.subtitle")}
          linkTitle={t("titlecard-zeacademy.linkTitle")}
          link={`/${i18n.language}/academy/catalogue`}
        />
        <FeaturedCafeContent
          title={t("titlecard-zecafe.title")}
          subtitle={t("titlecard-zecafe.subtitle")}
          linkTitle={t("titlecard-zecafe.linkTitle")}
          category={newsCategory}
          link={`/${i18n.language}/cafe/catalogue`}
        />
        <div className="section-divider">
          {PreviewSections[lang].map((section) => (
            <SectionComingSoon
              key={section.title}
              title={section.title}
              body={section.body}
            />
          ))}
        </div>
      </div>
      <PageHeadingWithImage
        className="ze-about"
        title={t("hub-about-zefi.title")}
        yellowDividerSmall={true}
        isPageHeading={false}
        body={t("hub-about-zefi.body")}
        children={
          <Link to={`/${i18n.language}/about`}>
            <Button
              buttonWhite={false}
              name={t("hub.about-zefi-readmore")}
            ></Button>
          </Link>
        }
      />
    </div>
  );
};

export default HubPage;
